import { lazy } from "react";
import { Route } from "react-router-dom";
import UserTypeComponentSplitter from "components/v1/navigation/UserTypeComponentSplitter";
import FeatureAccessCheck from "components/v1/security/FeatureAccessCheck";
import PageNotFound from "pages/v1/main/PageNotFound";
const CertificationsListDiversity = lazy(() => import("./CertificationsListDiversity"));
const CertificationsListVendor = lazy(() => import("./CertificationsListVendor"));
const CertificationApplicationsListDiversity = lazy(() => import("./CertificationApplicationsListDiversity"));

const certificationsRoutes = 
<>
    <Route path="certifications/records-list" element={<UserTypeComponentSplitter diversityComponent={<FeatureAccessCheck featureAccess="ProcessCertifications"><CertificationsListDiversity /></FeatureAccessCheck>} vendorComponent={<CertificationsListVendor />} />} />;
    <Route path="certifications/applications/records-list" element={<UserTypeComponentSplitter diversityComponent={<CertificationApplicationsListDiversity />} vendorComponent={<PageNotFound />} />} />;
</>;
export default certificationsRoutes;